import { useTranslation } from 'react-i18next'

export const DayNames = () => {
  const { t } = useTranslation()
  return (
    <div className="row day-names">
      <span className="day">{t('days.mon')}</span>
      <span className="day">{t('days.tue')}</span>
      <span className="day">{t('days.wed')}</span>
      <span className="day">{t('days.thur')}</span>
      <span className="day">{t('days.fri')}</span>
      <span className="day">{t('days.sat')}</span>
      <span className="day">{t('days.sun')}</span>
    </div>
  )
}
